import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from "../../core/visbos-core/components/abstract-visbos.component";
import {ApolloQueryObservable} from "apollo-angular";
import {Vehicle} from "../../fleet/model/vehicle.type";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ActionBarAction} from "../../core/visbos-core/ui/navigation/action-bar/action-bar.component";
import {GenericModalComponent} from "../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {SessionActions} from "../../shared/actions";
import {FleetService} from "../../fleet/services/fleet.service";
import {BarcodeService} from "../../identity/services/barcode.service";
import {FileService} from "../../core/visbos-core/http/file.service";
import {VehicleFormComponent} from "../../fleet/components/vehicle-form/vehicle-form.component";
import {MessageType} from "../../shared/redux-store/session";
import {ClientService} from "../../crm/services/client.service";
import {Client} from "../../shared/view-model/crm/client.type";
import {ClientFormComponent} from "../../crm/client/client-form/client-form.component";
import {AdministrationUnit} from "../../shared/view-model/organization/administration-unit.type";
import {
  AdministrationUnitService,
  FetchAdminUnitsResult
} from "../../organization/services/administration_unit_service/administration-unit.service";

@Component({
  selector: 'vb-accounting-units-view',
  templateUrl: './accounting-units-view.component.html',
  styleUrls: ['./accounting-units-view.component.css']
})
export class AccountingUnitsViewComponent extends AbstractVisbosComponent implements OnInit {

  private vehicles$: ApolloQueryObservable<any>;
  public vehicles: Vehicle[] = [];

  //TODO: Migrate Apollo
  private clients$: ApolloQueryObservable<any>;
  public clients: Client[] = [];

  private adminUnits$: ApolloQueryObservable<FetchAdminUnitsResult>;
  public adminUnits: AdministrationUnit[] = [];

  currentVehicleControl: FormGroup;
  currentClientControl: FormGroup;

  selectedClients: string[] = [];
  selectedVehicles: string[] = [];
  selectedAdminUnits: string[] = [];
  selected: string[] = [];

  actions: ActionBarAction[] = [
    {
      icon: 'fa-plus',
      label: 'Neues Fahrzeug',
      action: () => this.showAddVehicleModal.apply(this),
      helpText: 'Ein neues Fahrzeug anlegen'
    },
    {
      icon: 'fa-plus',
      label: 'Neuer Klient',
      action: () => this.showAddClientModal.apply(this),
      helpText: 'Einen neuen Klienten anlegen'
    },
    {
      icon: 'fa-barcode',
      label: 'Kostenstellen-Barcodes erzeugen',
      action: () => this.generateBarcodesClicked.apply(this),
      disabled: () => this.selected.length < 1,
      helpText: 'Barcode-Schilder für die ausgewählten Kostenstellen als PDF generieren'
    }
  ];

  @ViewChild('vehicleModal')
  vehicleModal: GenericModalComponent;

  @ViewChild('clientModal')
  clientModal: GenericModalComponent;

  @ViewChild('clientForm')
  clientForm: ClientFormComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder,
              private fleetService: FleetService, private clientService: ClientService, private adminUnitService: AdministrationUnitService,
              private bcService: BarcodeService, private fileService: FileService) {
    super(sessionActions, cd);
  }


  ngOnInit(): void {
    super.ngOnInit();

    this.vehicles$ = this.fleetService.fetchVehicles();
    this.addComponentData(this.vehicles$);
    this.dataSubscriptions.push(this.vehicles$.subscribe(res => this.vehicles = res.data.vehicles));

    this.clients$ = this.clientService.getClients();
    this.addComponentData(this.clients$);
    this.dataSubscriptions.push(this.clients$.subscribe(res => this.clients = res.data.clients));

    this.adminUnits$ = this.adminUnitService.getAdminUnitsWithEAN();
    this.addComponentData(this.adminUnits$);
    this.addSubscription(this.adminUnits$.subscribe(res => this.adminUnits = res.data.fetchAdminUnits));

  }

  showAddVehicleModal() {
    this.currentVehicleControl = VehicleFormComponent.initControl(this.fb);
    this.vehicleModal.show();
  }

  public saveVehicleClicked() {
    const vehicleData = this.currentVehicleControl.value;
    this.fleetService.createVehicle(vehicleData).toPromise()
      .then(res => this.sessionActions.pushMessage("Fahrzeug erfolgreich hinzugefügt!", MessageType.SUCCESS))
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Hinzufügen des Fahrzeugs!"));
  }

  showAddClientModal() {
    this.currentClientControl = ClientFormComponent.initControl(this.fb);
    this.clientModal.show();
  }

  public saveClientClicked() {
    this.clientForm.createOrUpdateClient(this.currentClientControl.value);
  }

  generateBarcodesClicked() {

    let res = this.bcService.generateAccountingUnitBarcodesPdf(this.selected);
    this.sessionActions.pushMessage("Die Barcode-PDF wird generiert, dies kann einen Moment dauern...", MessageType.INFO, "PDF erzeugen");

    res.toPromise()
      .then(res => {
        let pdfString = res.data.generateAccountingUnitBarcodesPDF;
        let blob = this.fileService.base64toBlob(pdfString, 'application/pdf', 512);
        this.fileService.saveAs(blob, 'kostenstellen-barcodes.pdf');
      })
      .catch(err => {
        this.sessionActions.throwError(err, "Fehler bei der Generierung der Barcodes!")
      });

  }

  selectedVehiclesChanged(selected: string[]) {
    this.selectedVehicles = selected;
    this.selectedChanged();
  }

  selectedClientsChanged(selected: string[]) {
    this.selectedClients = selected;
    this.selectedChanged();
  }

  selectedAdminUnitsChanged(selected: string[]) {
    this.selectedAdminUnits = selected;
    this.selectedChanged();
  }

  selectedChanged() {
    this.selected = [...this.selectedAdminUnits, ...this.selectedVehicles, ...this.selectedClients];
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/accounting-units-view/accounting-units-view.component.ts